module.exports = __webpack_public_path__ + "static/media/cathedral.e16e5e2a.jpg";